import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["mobileSwitch", "wSize", "width", "className"],
  _excluded2 = ["prefixCls", "footer", "visible", "wrapClassName", "centered", "getContainer", "closeIcon", "focusTriggerAfterClose", "closable"];
import classNames from "classnames";
import Dialog from "rc-dialog";
import * as React from "react";
import Button from "../../Button";
import { ConfigContext } from "../../ConfigProvider";
import { getConfirmLocale } from "./locale";
import { IconClose16pxRegular } from "@pionex-web-kit/icons";
import { convertLegacyProps } from "../../Button/Button";
import { getTransitionName } from "../../hack/_util/motion";
import { canUseDocElement } from "../../hack/_util/styleChecker";
import useMedia from "../../hooks/useMedia";
import LocaleReceiver from "../../LocaleProvider/LocaleReceiver";
import MobileDrawer from "../MobileDrawer";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var mousePosition;
var DEFAULT_WIDTH = {
  DEFAULT: 520,
  SM: 400
};

// ref: https://github.com/ant-design/ant-design/issues/15795
var getClickPosition = function getClickPosition(e) {
  mousePosition = {
    x: e.pageX,
    y: e.pageY
  };
  // 100ms 内发生过点击事件，则从点击位置动画展示
  // 否则直接 zoom 展示
  // 这样可以兼容非点击方式展开
  setTimeout(function () {
    mousePosition = null;
  }, 100);
};

// 只有点击事件支持从鼠标位置动画展开
if (canUseDocElement()) {
  document.documentElement.addEventListener("click", getClickPosition, true);
}
var Modal = function Modal(_ref) {
  var _classNames;
  var _ref$mobileSwitch = _ref.mobileSwitch,
    mobileSwitch = _ref$mobileSwitch === void 0 ? "drawer" : _ref$mobileSwitch,
    wSize = _ref.wSize,
    width = _ref.width,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _React$useContext = React.useContext(ConfigContext),
    getContextPopupContainer = _React$useContext.getPopupContainer,
    getPrefixCls = _React$useContext.getPrefixCls,
    direction = _React$useContext.direction;
  var handleCancel = function handleCancel(e) {
    var onCancel = props.onCancel;
    onCancel === null || onCancel === void 0 ? void 0 : onCancel(e);
  };
  var handleOk = function handleOk(e) {
    var onOk = props.onOk;
    onOk === null || onOk === void 0 ? void 0 : onOk(e);
  };
  var renderFooter = function renderFooter(locale) {
    var okText = props.okText,
      okType = props.okType,
      cancelText = props.cancelText,
      confirmLoading = props.confirmLoading;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        onClick: handleCancel,
        shape: "round",
        ghost: true,
        type: "primary"
      }, props.cancelButtonProps), {}, {
        children: cancelText || (locale === null || locale === void 0 ? void 0 : locale.cancelText)
      })), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread(_objectSpread({
        shape: "round"
      }, convertLegacyProps(okType)), {}, {
        loading: confirmLoading,
        onClick: handleOk
      }, props.okButtonProps), {}, {
        children: okText || (locale === null || locale === void 0 ? void 0 : locale.okText)
      }))]
    });
  };
  var customizePrefixCls = props.prefixCls,
    footer = props.footer,
    visible = props.visible,
    wrapClassName = props.wrapClassName,
    _props$centered = props.centered,
    centered = _props$centered === void 0 ? true : _props$centered,
    getContainer = props.getContainer,
    closeIcon = props.closeIcon,
    _props$focusTriggerAf = props.focusTriggerAfterClose,
    focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf,
    _props$closable = props.closable,
    closable = _props$closable === void 0 ? false : _props$closable,
    restProps = _objectWithoutProperties(props, _excluded2);
  var prefixCls = getPrefixCls("modal", customizePrefixCls);
  var rootPrefixCls = getPrefixCls();
  var defaultFooter =
  /*#__PURE__*/
  // @ts-ignore
  _jsx(LocaleReceiver, {
    componentName: "Modal",
    defaultLocale: getConfirmLocale(),
    children: renderFooter
  });
  var closeIconToRender = /*#__PURE__*/_jsx("span", {
    className: "".concat(prefixCls, "-close-x"),
    children: closeIcon || /*#__PURE__*/_jsx(IconClose16pxRegular, {
      className: "".concat(prefixCls, "-close-icon"),
      size: 16
    })
  });
  var wrapClassNameExtended = classNames(wrapClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-centered"), !!centered), _defineProperty(_classNames, "".concat(prefixCls, "-wrap-rtl"), direction === "rtl"), _classNames));
  var computeWidth = width;
  computeWidthBlock: {
    if (width) {
      break computeWidthBlock;
    }
    if (wSize === "small") {
      computeWidth = DEFAULT_WIDTH.SM;
      break computeWidthBlock;
    }
    computeWidth = DEFAULT_WIDTH.DEFAULT;
  }

  // TODO: isMobile等等集成在context里面
  var isMobile = useMedia("(max-width: 767px)");
  if (isMobile) {
    if (mobileSwitch === "drawer") {
      return /*#__PURE__*/_jsx(MobileDrawer, _objectSpread(_objectSpread({}, restProps), {}, {
        className: classNames(className, _defineProperty({}, "".concat(prefixCls, "-sm"), !width && wSize === "small"))
        // width={computeWidth}
        ,
        closable: closable,
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        wrapClassName: wrapClassNameExtended,
        footer: footer === undefined ? defaultFooter : footer,
        visible: visible
        // @ts-ignore
        ,
        onCancel: handleCancel,
        closeIcon: closeIconToRender,
        focusTriggerAfterClose: focusTriggerAfterClose,
        transitionName: getTransitionName(rootPrefixCls, "zoom", props.transitionName),
        maskTransitionName: getTransitionName(rootPrefixCls, "fade", props.maskTransitionName)
      }));
    }
  }
  return /*#__PURE__*/_jsx(Dialog, _objectSpread(_objectSpread({}, restProps), {}, {
    className: classNames(className, _defineProperty({}, "".concat(prefixCls, "-sm"), !width && wSize === "small")),
    width: computeWidth,
    closable: closable,
    getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
    prefixCls: prefixCls,
    wrapClassName: wrapClassNameExtended,
    footer: footer === undefined ? defaultFooter : footer,
    visible: visible,
    mousePosition: mousePosition
    // @ts-ignore
    ,
    onClose: handleCancel,
    closeIcon: closeIconToRender,
    focusTriggerAfterClose: focusTriggerAfterClose,
    transitionName: getTransitionName(rootPrefixCls, "zoom", props.transitionName),
    maskTransitionName: getTransitionName(rootPrefixCls, "fade", props.maskTransitionName)
  }));
};
Modal.defaultProps = {
  // width: 520,
  confirmLoading: false,
  visible: false,
  okType: "primary"
};
export default Modal;